import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/table";
import { Subheading } from "../components/heading";
import { Listbox, ListboxOption } from "../components/listbox-new";
import { Combobox } from "../components/combobox-new2";
import { Field, Label } from "../components/fieldset";
import { Textarea } from "../components/textarea";
import { Button } from "../components/button";
import config from "../config.js";
import { Loader } from "../components/loader";
import { Input } from "../components/input"; 
import { Radio, RadioField, RadioGroup } from '../components/radio'
import { ConfirmDialog } from "../components/ConfirmDialog";

export function TitlePermutation({ onChange, optionsAI, parentData = {} }) {
  const [activeRuleId, setActiveRuleId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const rulesContainerRef = useRef(null);
  const resultsContainerRef = useRef(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [emphasisList, setEmphasisList] = useState([]);
  const [commonCategory, setCommonCategory] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingCategory, setPendingCategory] = useState(null);

  const [activeRuleSelectTab, setActiveRuleSelectTab] = useState(null);
  const [selectedRules, setSelectedRules] = useState([]);
  
	const [showAddRuleInput, setShowAddRuleInput] = useState(false);
const [newRuleText, setNewRuleText] = useState("");
	
	
  const [defaultRulesList, setDefaultRulesList] = useState([]);
  // Helper to generate emphasis options for a category
  const getEmphasisOptions = (categoryValue) => {
    const selectedCat = emphasisList.find((cat) => cat.category === categoryValue);
    const emphasisObj = selectedCat?.emphasis ?? {};
    const opts = Object.entries(emphasisObj).map(([key, label]) => ({
      value: key,
      label,
    }));
    return opts;
  };

  const comboboxOptions = [
    ...optionsAI.map((option) => ({
      label: option.ai_key,
      value: `Predefined:${option.ai_instruction}`,
    })),
    { label: "Custom Instructions", value: "custom" },
  ];
  
useEffect(() => {
  const fetchDefaultPolicies = async () => {
    try {
      const res = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_default_policy`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const data = await res.json();

      if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === true && Array.isArray(data.polityList)) {
        // Convert { label, value } → { id, text }
        const formatted = data.polityList.map((p, idx) => ({
          id: idx + 1,
          text: p.label,
        }));
        setDefaultRulesList(formatted);
      }
    } catch (err) {
      console.error("Error fetching default policies:", err);
    }
  };

  fetchDefaultPolicies();
}, []);

  const [tabs, setTabs] = useState([
    {
      id: Date.now(),
      title: "",
      category: "",
      emphasis: "",
	  default_policy:"yes",
      dynamicEmphasisOpt: [],
      rules: [{ id: Date.now(), value: "", isEditing: true }],
      results: [],
      allResults: [],
      start: 0,
      limit: 2,
      hasMoreResults: true,
      error: "",
      ai_rule: [],
      ai_example: [],
    },
  ]);
  //Result Reset while change title depth
  useEffect(() => {
    // Clear AI results when title_depth changes
    setTabs((prevTabs) =>
      prevTabs.map((tab) => ({
        ...tab,
        results: [],
        allResults: [],
        ai_rule: [],
        ai_example: [],
        start: 0,
        hasMoreResults: true,
      }))
    );
  }, [parentData.title_depth]);
  // Load default emphasis list from API
  useEffect(() => {
    const defaultEmphasis = async () => {
      try {
        const policy = await fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_default_emphasis`,
          { method: "GET", credentials: "include" }
        );
        const data = await policy.json();
        if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
          window.location.href = `/${config.appPath}`;
        } else if (data.emphasisList && Array.isArray(data.emphasisList)) {
          setEmphasisList(data.emphasisList);
          setCategoryOptions(data.emphasisList.map((item) => item.category));
        }
      } catch (error) {
        console.error("Error fetching emphasis list:", error);
      }
    };
    defaultEmphasis();
  }, []);

const handleCommonCategoryChange = (selectedCategory) => {
  setCommonCategory(selectedCategory);

  // update all tabs with this common category
  setTabs(prev =>
    prev.map(tab => ({
      ...tab,
      category: selectedCategory,
      // reset per-tab results/emphasis when category changes
      emphasis: "",
      results: [],
      allResults: [],
      start: 0,
      hasMoreResults: true,
      ai_rule: [],
      ai_example: [],
    }))
  );
};

  // Prepopulate dynamic emphasis options once emphasisList is loaded
  useEffect(() => {
    if (tabs.length && emphasisList.length) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) => ({
          ...tab,
          dynamicEmphasisOpt: getEmphasisOptions(tab.category),
        }))
      );
    }
  }, [emphasisList]);

  // Notify parent on tabs change
  useEffect(() => {
    const data = {};
    tabs.forEach((tab, index) => {
      const tabName = `Permutation ${index + 1}`;
      data[`rule${index + 1}`] = {
        title: tabName,
        emphasis: tab.emphasis,
		default_policy:tab.default_policy,
		category:tab.category,
        rules: tab.rules
          .map((r) => (typeof r.value === "string" ? r.value.trim() : ""))
          .filter(Boolean)
          .map((val) =>
            typeof val === "string" && val.startsWith("custom:") ? val.slice(7) : val
          ),
        ai_dynamic_rule: tab.ai_rule || [],
        ai_dynamic_example: tab.ai_example || [],
        ai_results: tab.results || [],
      };
    });
    onChange(data);
  }, [tabs, onChange]);

  const validateTab = (currentTab, index) => {
    const hasEmphasis =
      currentTab.emphasis && currentTab.emphasis.trim() !== "";
    const hasAiRule =
      Array.isArray(currentTab.rules) &&
      currentTab.rules.some((rule) => rule.value && rule.value.trim() !== "");

    const updatedTabs = [...tabs];

    /*if (!hasEmphasis && !hasAiRule) {
      updatedTabs[index].error =
        "Please provide either an Emphasis or at least one AI instruction before searching examples.";
      setTabs(updatedTabs);
      return false;
    }*/
    if (!hasEmphasis ) {
      updatedTabs[index].error =
        "Please select an emphasis before searching for examples.";
      setTabs(updatedTabs);
      return false;
    }
	  
    // clear error if valid
    updatedTabs[index].error = "";
    setTabs(updatedTabs);
    return true;
  };

  const handleSearch = async () => {
    const currentTab = tabs[selectedTab];
    if (!validateTab(currentTab, selectedTab)) return;

    const defaultPolicy = currentTab.default_policy;
	const emphasisValue = currentTab.emphasis;
    const aiInstructions = currentTab.rules
      .filter((rule) => rule.value && rule.value.trim() !== "")
      .map((rule) => {
        return typeof rule.value === "string" &&
          rule.value.startsWith("custom:")
          ? rule.value.slice(7)
          : rule.value;
      });

    setLoading(true);
    try {
      const response = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
			title_depth: parentData.title_depth,
            category: parentData.fullPath,
            brand: parentData.brand,
            impressions: parentData.impressions,
            sku_limit: currentTab.limit,
            batch_type: parentData.batch_type,
            emphasis: emphasisValue,
			default_policy:defaultPolicy,
            ai_instructions: aiInstructions,
          }),
        }
      );

      const data = await response.json();

      if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === "success") {
        const fullResults = data.records || [];
        const updated = [...tabs];
		
		  if (fullResults.length === 0) {  
            updated[selectedTab] = {
              ...updated[selectedTab],
              results: [],
              allResults: [],
              ai_rule: [],
              ai_example: [],
              error: "No products found for the selected product filters.",
            };
            setTabs(updated);
            setLoading(false);
            return;
          }
		  
        updated[selectedTab] = {
          ...updated[selectedTab],
          ai_rule: data.ai_rules || [],
          ai_example: data.ruleExample || [],
          results: fullResults.slice(0, 2),
          allResults: fullResults,
          start: fullResults.length,
          hasMoreResults: fullResults.length === currentTab.limit,
        };
        setTabs(updated);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

const loadMoreResults = async () => {
  const currentTab = tabs[selectedTab];
  if (!currentTab.hasMoreResults || currentTab.isLoadingMore) return;

  // mark only this tab as loading more
  setTabs(prev => {
    const updated = [...prev];
    updated[selectedTab] = { ...updated[selectedTab], isLoadingMore: true };
    return updated;
  });

  // scroll to bottom immediately so loader is visible
  setTimeout(() => {
    if (resultsContainerRef.current) {
      resultsContainerRef.current.scrollTo({
        top: resultsContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, 100);

  try {
    const response = await fetch(
      `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product_more`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title_depth: parentData.title_depth,
          category: parentData.fullPath,
          brand: parentData.brand,
          impressions: parentData.impressions,
          sku_limit: currentTab.limit,
          batch_type: parentData.batch_type,
          ai_rule: currentTab.ai_rule,
          ai_example: currentTab.ai_example,
          start: currentTab.start,
        }),
      }
    );

    const data = await response.json();

    if (data.status === "success") {
      const moreResults = data.records || [];

      setTabs(prev => {
        const updated = [...prev];
        const t = updated[selectedTab];
        updated[selectedTab] = {
          ...t,
          results: [...t.results, ...moreResults],
          allResults: [...t.allResults, ...moreResults],
          start: t.start + moreResults.length,
          hasMoreResults: moreResults.length > 0,
          isLoadingMore: false, // stop load-more loader
        };
        return updated;
      });

      // scroll down again once items added
      setTimeout(() => {
        if (resultsContainerRef.current) {
          resultsContainerRef.current.scrollTo({
            top: resultsContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 150);
    }
  } catch (error) {
    console.error("Load More Error:", error);
    setTabs(prev => {
      const updated = [...prev];
      updated[selectedTab] = { ...updated[selectedTab], isLoadingMore: false };
      return updated;
    });
  }
};




  const loadMoreResultsOld = async () => {
    const currentTab = tabs[selectedTab];
    if (!currentTab.hasMoreResults) return; // no more to load

    setLoading(true);
    try {
      const response = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product_more`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
			title_depth: parentData.title_depth,
            category: parentData.fullPath,
            brand: parentData.brand,
            impressions: parentData.impressions,
            sku_limit: currentTab.limit,
            batch_type: parentData.batch_type,
            ai_rule: currentTab.ai_rule,
            ai_example: currentTab.ai_example,
            start: currentTab.start, // <-- pass start for pagination
          }),
        }
      );

      const data = await response.json();

      if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === "success") {
        const moreResults = data.records || [];
        const updated = [...tabs];
        updated[selectedTab].results = [
          ...updated[selectedTab].results,
          ...moreResults,
        ];
        updated[selectedTab].allResults = [
          ...updated[selectedTab].allResults,
          ...moreResults,
        ];
        updated[selectedTab].start += moreResults.length; // update start index
        updated[selectedTab].hasMoreResults =
          moreResults.length === currentTab.limit; // check if more to load

        setTabs(updated);

        setTimeout(() => {
          if (resultsContainerRef.current) {
            resultsContainerRef.current.scrollTop =
              resultsContainerRef.current.scrollHeight;
          }
        }, 100);
      }
    } catch (err) {
      console.error("API error (More Results):", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (index, field, value) => {
    const updated = [...tabs];
    const currentTab = updated[index];
    const isEmphasisChange = field === "emphasis" && currentTab[field] !== value;

    updated[index][field] = value;
    updated[index].error = "";

    if (isEmphasisChange) {
      // Clear AI fields and results on Emphasis change
      updated[index].results = [];
      updated[index].allResults = [];
      updated[index].start = 0;
      updated[index].hasMoreResults = true;
      updated[index].ai_rule = [];
      updated[index].ai_example = [];
    }

    setTabs(updated);
  };

const handleCategoryChangeOld = (selectedCategory) => {
  const categoryObj = emphasisList.find(
    (cat) => cat.category === selectedCategory
  );

  const newEmphasisOpt =
    categoryObj && categoryObj["emphasis"]
      ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
          // swap value and label
          value: label, // the value returned
          label: key,   // what is shown in dropdown
        }))
      : [];

  const updated = [...tabs];
  updated[selectedTab].category = selectedCategory;
  updated[selectedTab].dynamicEmphasisOpt = newEmphasisOpt;
  updated[selectedTab].emphasis = "";
  updated[selectedTab].results = [];
  updated[selectedTab].allResults = [];
  updated[selectedTab].start = 0;
  updated[selectedTab].hasMoreResults = true;
  updated[selectedTab].ai_rule = [];
  updated[selectedTab].ai_example = [];
  updated[selectedTab].error = "";

  setTabs(updated);
};

const handleCategoryChange = (selectedCategory) => {
  const currentCategory = tabs[0]?.category || null;

  // check if any tab has user input
  const hasUserData = tabs.some(
    (tab) =>
      (tab.emphasis && tab.emphasis !== "") ||
      (Array.isArray(tab.ai_example) && tab.ai_example.length > 0) ||
      (Array.isArray(tab.ai_rule) && tab.ai_rule.length > 0)
  );

  // if changing to a new category that has data — show confirm modal
  if (currentCategory && currentCategory !== selectedCategory && hasUserData) {
    setPendingCategory(selectedCategory);
    setShowConfirm(true);
    return;
  }

  applyCategoryChange(selectedCategory);
};

  const applyCategoryChange = (selectedCategory) => {
  const categoryObj = emphasisList.find((cat) => cat.category === selectedCategory);
  const newEmphasisOpt =
    categoryObj && categoryObj["emphasis"]
      ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
          value: label,
          label: key,
        }))
      : [];

  setTabs((prev) =>
    prev.map((t) => ({
      ...t,
      category: selectedCategory,
      dynamicEmphasisOpt: newEmphasisOpt,
      emphasis: null,
      results: [],
      allResults: [],
      start: 0,
      hasMoreResults: true,
      ai_rule: [],
      ai_example: [],
      error: "",
    }))
  );
};





  const handleRuleChange = (tabIndex, ruleId, newValue) => {
    const updatedTabs = [...tabs];
    const tab = updatedTabs[tabIndex];
    const existingRule = tab.rules.find((rule) => rule.id === ruleId);
    const existingValue = existingRule?.value;
    const isChanged = existingValue !== newValue;

    updatedTabs[tabIndex].rules = tab.rules.map((rule) =>
      rule.id === ruleId ? { ...rule, value: newValue } : rule
    );

    if (isChanged) {
      updatedTabs[tabIndex].results = [];
      updatedTabs[tabIndex].allResults = [];
      updatedTabs[tabIndex].start = 0;
      updatedTabs[tabIndex].hasMoreResults = true;
      updatedTabs[tabIndex].ai_rule = [];
      updatedTabs[tabIndex].ai_example = [];
    }

    updatedTabs[tabIndex].error = "";
    setTabs(updatedTabs);
  };

  const addRule = (tabIndex) => {
    const updated = [...tabs];
    updated[tabIndex].rules.push({ id: Date.now(), value: "", isEditing: true });
    setTabs(updated);
    // Scroll to bottom after a slight delay
    setTimeout(() => {
      if (rulesContainerRef.current) {
        rulesContainerRef.current.scrollTop = rulesContainerRef.current.scrollHeight;
      }
    }, 0);
  };

  const removeRule = (tabIndex, ruleId) => {
    const updated = [...tabs];
    const tab = updated[tabIndex];

    const ruleToRemove = tab.rules.find((r) => r.id === ruleId);

    updated[tabIndex].rules = tab.rules.filter((rule) => rule.id !== ruleId);

    if (ruleToRemove && ruleToRemove.value?.trim()) {
      updated[tabIndex].results = [];
      updated[tabIndex].allResults = [];
      updated[tabIndex].start = 0;
      updated[tabIndex].hasMoreResults = true;
      updated[tabIndex].ai_rule = [];
      updated[tabIndex].ai_example = [];
    }

    setTabs(updated);
  };

 const addTab = () => {
  const currentCategory = tabs[selectedTab]?.category || "";
  const categoryObj = emphasisList.find((cat) => cat.category === currentCategory);

  const newEmphasisOpt =
    categoryObj && categoryObj["emphasis"]
      ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
          value: label,
          label: key,
        }))
      : [];

  const newTab = {
    id: Date.now(),
    title: "",
    category: currentCategory,
    emphasis: "",
    default_policy: "yes",
    dynamicEmphasisOpt: newEmphasisOpt,
    rules: [{ id: Date.now(), value: "", isEditing: true }],
    results: [],
    allResults: [],
    start: 0,
    limit: 2,
    hasMoreResults: true,
    error: "",
    ai_rule: [],
    ai_example: [],
  };

  setTabs((prevTabs) => [...prevTabs, newTab]);
  setSelectedTab(tabs.length);
};

  const addTabOld = () => {
    setTabs([
      ...tabs,
      {
        id: Date.now(),
        title: "",
        category: "",
        emphasis: "",
		default_policy:"yes",
        dynamicEmphasisOpt: [],
        rules: [{ id: Date.now(), value: "", isEditing: true }],
        results: [],
        allResults: [],
        start: 0,
        limit: 2,
        hasMoreResults: true,
        error: "",
        ai_rule: [],
        ai_example: [],
      },
    ]);
    setSelectedTab(tabs.length);
  };

  const removeTab = (index) => {
    if (tabs.length === 1) return;
    const updated = tabs.filter((_, i) => i !== index);
    setTabs(updated);
    setSelectedTab((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const tab = tabs[selectedTab];

  return (
    <div className="text-black-800 w-full border border-gray-300 rounded-t-lg">
	  
    {/* Category Selector */}
    <div className="p-4 border-b border-gray-200">
      <Subheading className="mb-2">
        Select Category
      </Subheading>
      <Listbox
        id="category"
        name="category"
        value={tab.category || ""}
        onChange={handleCategoryChange}
        className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm"
      >
        {categoryOptions.map((cat) => (
          <ListboxOption key={cat} value={cat}>
            {cat}
          </ListboxOption>
        ))}
      </Listbox>
    </div>
		  
      {/* Tabs */}
      <div className="w-full flex overflow-x-auto mb-4 border-b border-gray-300">
        {tabs.map((tab, index) => {
          const rawTitle = tab?.title?.trim() || `Permutation ${index + 1}`;
          const truncatedTitle =
            rawTitle.length > 15 ? rawTitle.slice(0, 15) + "..." : rawTitle;

          return (
            <div key={tab.id} className="relative">
              <Button
                default={selectedTab === index}
                plain={selectedTab !== index}
                type="button"
                color={`${selectedTab === index ? "zinc" : ""}`}
                className={`border-0 !border-r !border-gray-300 ${
                  selectedTab === index ? "!rounded-t-md !rounded-b-none" : "!rounded-none "
                }`}
                onClick={() => setSelectedTab(index)}
                title={rawTitle}
              >
                {truncatedTitle}
              </Button>
              {tabs.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeTab(index)}
                  className="absolute top-0 right-0 px-1 text-xs text-red-600 hover:text-red-800 cursor-pointer"
                >
                  ×
                </button>
              )}
            </div>
          );
        })}
        <Button plain type="button" onClick={addTab}>
          +
        </Button>
      </div>

      {tab.error && (
        <div className="mt-2 ml-4 mr-4 text-sm text-red-600 font-medium">{tab.error}</div>
      )}

      {/* LEFT COLUMN */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 ml-4 mr-4">
        <div className="space-y-8 border-r border-gray-300">
          <section className="grid gap-x-8 gap-y-6 sm:grid-cols-1 md:grid-cols-1 mr-8"> 
  <Field> 

    {/* Emphasis Selector for normal categories */}
    {tab.category !== "custom" && tab.dynamicEmphasisOpt?.length > 0 && (
      <div className="mb-2">
        <Subheading className="mb-2">
          Title Emphasis
        </Subheading>
        <Listbox
  id="emphasis"
  name="emphasis"
  value={tab.emphasis} // stores the "label" as value
  onChange={(value) => handleTabChange(selectedTab, "emphasis", value)}
  className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm"
>
  {tab.dynamicEmphasisOpt.map((opt) => (
    <ListboxOption key={opt.value} value={opt.value}>
      {opt.label} {/* show key */}
    </ListboxOption>
  ))}
</Listbox>
      </div>
    )}

    {/* Custom Emphasis Input for 'custom' category */}
    {tab.category === "Custom" && (
      <div className="mb-2">
        <Subheading className="mb-2">
           Custom Title Emphasis
        </Subheading>
        <Input
          id="customEmphasis"
          type="text"
          value={tab.emphasis || ""}
          onChange={(e) =>
            handleTabChange(selectedTab, "emphasis", e.target.value)
          }
          placeholder="Enter your custom emphasis here" 
        />
      </div>
    )}
  </Field>
</section>

<section>
	<Subheading className="mb-2">Title Strategies</Subheading> 

<RadioGroup
  name="default_policy"
  value={tab?.default_policy || ""}
  onChange={(val) => {
    handleTabChange(selectedTab, "default_policy", val);
    if (val === "choose") {
      setActiveRuleSelectTab(selectedTab);  
      setSelectedRules(
        tabs[selectedTab].rules.map((r) =>
          defaultRulesList.findIndex((d) => d.text === r.value) + 1
        ).filter((id) => id > 0)
      );
    } else if (val === "yes" || val === "no") {
    // Clear rules for this specific tab
    setTabs((prevTabs) => {
      const updated = [...prevTabs];
      // guard: if selectedTab is out-of-range just return prev
      if (selectedTab < 0 || selectedTab >= updated.length) return prevTabs;
      updated[selectedTab] = { ...updated[selectedTab], rules: [] };
      return updated;
    });

    // Clear any popup selections and checkbox selection state
    setSelectedRules([]);
    setActiveRuleSelectTab(null);
  }
}}
  className="flex gap-6 ml-4"
>

    <RadioField className="flex gap-2">
      <Radio value="yes" />
      <Label>Yes</Label>
    </RadioField>
    <RadioField className="flex gap-2" >
      <Radio value="no" />
      <Label>No</Label>
    </RadioField>
    <RadioField className="flex gap-2">
      <Radio value="choose"
         onClick={() => {
			  setActiveRuleSelectTab(selectedTab); 
			  setSelectedRules(
					tabs[selectedTab].rules.map((r) =>
					  defaultRulesList.findIndex((d) => d.text === r.value) + 1
					).filter((id) => id > 0)
				  );
			}}/>
      <Label>Choose which apply</Label>
    </RadioField>   
    </RadioGroup> 
</section>



          {/* Rules Table */}
          <section className="hidden">
            <Subheading>Add AI Instructions</Subheading>
            <div className="max-h-70 overflow-y-auto" ref={rulesContainerRef}>
              <Table className="mb-2 !overflow-x-visible table-fixed">
                <colgroup>
                  <col className="w-6/8" />
                  <col className="w-2/8" />
                </colgroup>
                <TableHead className="sticky top-0 bg-white z-10">
                  <TableRow>
                    <TableHeader className="border-b-0">Instruction</TableHeader>
                    <TableHeader className="border-b-0">Options</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody className="border-b-0">
                  {tab.rules.map((rule, i) => (
                    <TableRow key={rule.id}>
                      <TableCell className="!px-2 !py-2 border-b-0">
                        {rule.isEditing ? (
                          <div className="flex gap-2">
                            <div
                              className={`${
                                typeof rule.value === "string" && rule.value.startsWith("custom:")
                                  ? "w-3/8"
                                  : "w-full"
                              } relative`}
                            >
                              <Combobox
                                name={`rule-${rule.id}`}
                                value={
                                  typeof rule.value === "string" && rule.value.startsWith("custom:")
                                    ? "custom"
                                    : rule.value || ""
                                }
                                onChange={(val) =>
                                  handleRuleChange(
                                    selectedTab,
                                    rule.id,
                                    val === "custom" ? "custom:" : val
                                  )
                                }
                                options={comboboxOptions.map((opt) => ({
                                  ...opt,
                                  disabled:
                                    opt.value !== "custom" &&
                                    tab.rules.some((r) => r.id !== rule.id && r.value === opt.value),
                                }))}
                                className="w-full rounded-md border border-gray-300 py-1 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              />
                            </div>
                            <div
                              className={`${
                                typeof rule.value === "string" && rule.value.startsWith("custom:")
                                  ? "w-5/8 mr-2"
                                  : "w-0"
                              } relative`}
                            >
                              {typeof rule.value === "string" && rule.value.startsWith("custom:") && (

                                <Textarea
                                  type="text"
                                  value={rule.value.replace(/^custom:/, "")}
                                  onFocus={() => setActiveRuleId(rule.id)}
                                  onBlur={() => setActiveRuleId(null)}
                                  onChange={(e) =>
                                    handleRuleChange(
                                      selectedTab,
                                      rule.id,
                                      `custom:${e.target.value}`
                                    )
                                  }
                                  placeholder="Enter custom instruction"
                                  rows={1}
                                  className={`mt-2 ${activeRuleId === rule.id ? "h-24" : ""}`}
                                />
                              )}
                            </div>
                          </div>
                        ) : (
                          <span>{rule.value || "—"}</span>
                        )}
                      </TableCell>
                      <TableCell className="!px-2 !py-2 border-b-0">
                        <div className="flex gap-2">
                          {tab.rules.length > 1 && (
                            <Button
                              type="button"
                              onClick={() => removeRule(selectedTab, rule.id)}
                              className="mt-2 !h-[28px] !text-[12px] !px-2 !flex !items-center !justify-center !rounded-md"
                            >
                              Remove
                            </Button>
                          )}
                          {i === tab.rules.length - 1 && (
                            <Button
                              type="button"
                              onClick={() => addRule(selectedTab)}
                              color="white"
                              className="mt-2 !h-[28px] !text-[12px] !px-2 !flex !items-center !justify-center !rounded-md"
                            >
                              Add
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </section>
        </div>

        {/* RIGHT COLUMN */}
        <div>
          <div className="text-right mr-4 mb-4">
            {tab.results?.length > 0 && (
			  <Button
				color="zinc"
				type="button"
				disabled={tab.isLoadingMore} // only disable during load more
				onClick={loadMoreResults}
				className="!text-[12px]"
			  >
				{tab.isLoadingMore ? "Loading more..." : "More Results"}
			  </Button>
			)}

            {tab.results &&  tab.results.length === 0 && (
              <Button
                color="zinc"
                type="button"
                onClick={handleSearch}
                disabled={loading}
                className="!text-[12px]"
              >
                {loading ? "Searching..." : "Show Examples"}
              </Button>
            )}
          </div>
          <Field>
            <Subheading className="mb-2">Examples</Subheading>
            <div
              className="max-h-100 overflow-y-auto"
              ref={resultsContainerRef}
            >
              <Table className="mb-2 !overflow-x-visible">
                <TableHead className="sticky top-0 bg-white z-10 text-[13px]">
                  <TableRow>
                    <TableHeader>Product Image</TableHeader>
                    <TableHeader>Name</TableHeader>
                  </TableRow>
                </TableHead>
                


<TableBody>
  {/* CASE 1: show initial loader (only when no results yet) */}
  {loading && (!tab.results || tab.results.length === 0) && (
    <TableRow>
      <TableCell colSpan={3} className="py-4 text-center">
        <Loader />
      </TableCell>
    </TableRow>
  )}

  {/* CASE 2: show results */}
  {!loading &&
    Array.isArray(tab.results) &&
    tab.results.length > 0 &&
    tab.results.map((item, idx) => (
      <TableRow key={idx}>
        <TableCell className="!p-2">
          <img
            src={item.image}
            alt={item.name}
            className="h-[100px] w-[100px] object-cover rounded"
          />
        </TableCell>
        <TableCell className="!p-2 break-words whitespace-normal">
          <div className="font-semibold">Source Title:</div>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:text-indigo-800"
          >
            {item.name}
          </a>
          <div className="mt-1">
            <span className="font-semibold">AI Title:</span> {item.aiName}
          </div>
        </TableCell>
      </TableRow>
    ))}

  {/* CASE 3: "Loading more" spinner — bottom only */}
  {tab.isLoadingMore && (
    <TableRow>
      <TableCell colSpan={3} className="py-3 text-center"> 
 		<Loader />
        <div className="text-gray-500 text-sm mt-1">Loading more...</div>
      </TableCell>
    </TableRow>
  )}

  {/* CASE 4: Empty state */}
  {!loading &&
    !tab.isLoadingMore &&
    (!tab.results || tab.results.length === 0) && (
      <TableRow>
        <TableCell colSpan={3} className="py-4 text-center text-gray-500">
          No products found.
        </TableCell>
      </TableRow>
    )}
</TableBody>

              </Table>{" "}
            </div>
          </Field>
        </div>
      </div>

<ConfirmDialog
  isOpen={showConfirm}
  title="Confirm to Change Category?"
  message="Changing the category will reset all tabs, emphasis, and results. Do you want to continue?"
  onConfirm={() => {
    applyCategoryChange(pendingCategory);
    setShowConfirm(false);
    setPendingCategory(null);
  }}
  onCancel={() => {
    setShowConfirm(false);
    setPendingCategory(null);
  }}
/>

{activeRuleSelectTab !== null && (
  <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
    <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] p-8 overflow-y-auto">
       
<div className="flex justify-between items-center border-b border-gray-200 pb-3 mb-5">
  <h2 className="text-xl font-semibold text-gray-800">
    Select Default Title Strategies
  </h2>
  <button
    onClick={() => {
      setActiveRuleSelectTab(null);
      setSelectedRules([]);
    }}
    className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
    aria-label="Close"
  >
    ×
  </button>
</div>



<div className="space-y-3 max-h-[60vh] overflow-y-auto">
  {defaultRulesList.map((rule) => {
    const isSelected = selectedRules.includes(rule.id);
    return (
      <div
        key={rule.id}
        className={`flex justify-between items-center border rounded-lg p-3 transition-colors ${
          isSelected
            ? "bg-blue-50 border-blue-400"
            : "bg-gray-50 hover:bg-gray-100 border-gray-200"
        }`}
      >
        <p className="text-sm text-gray-800">{rule.text}</p>
        <div className="flex gap-4">
          <button type="button"
            onClick={() => {
              setSelectedRules((prev) =>
                prev.includes(rule.id)
                  ? prev.filter((id) => id !== rule.id) // unselect
                  : [...prev, rule.id] // select
              );
            }}
            className={`${
              isSelected
                ? "text-red-600 hover:underline"
                : "text-blue-600 hover:underline"
            } text-sm`}
          >
            {isSelected ? "Unselect" : "Select"}
          </button>
        </div>
      </div>
    );
  })}

  {/*  Inline "Add New Rule" Section */}
  <div className="flex justify-center mt-5 mb-5">
    {!showAddRuleInput ? (
      <button type="button"
        onClick={() => setShowAddRuleInput(true)}
        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
      >
        + Add New Rule
      </button>
    ) : (
      <div className="flex items-center gap-3 w-full">
        <input
          type="text"
          value={newRuleText}
          onChange={(e) => setNewRuleText(e.target.value)}
          placeholder="Enter new rule"
          className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button type="button"
          onClick={() => {
            if (!newRuleText.trim()) return;
            const newRule = {
              id: Date.now(),
              text: newRuleText.trim(),
            };
            setDefaultRulesList((prev) => [...prev, newRule]);
            setNewRuleText("");
            setShowAddRuleInput(false);
          }}
          className="text-green-600 text-sm hover:underline"
        >
          Save
        </button>
        <button type="button"
          onClick={() => {
            setNewRuleText("");
            setShowAddRuleInput(false);
          }}
          className="text-red-600 text-sm hover:underline"
        >
          Cancel
        </button>
      </div>
    )}
  </div>
</div>



      <div className="flex justify-end gap-3 mt-6">
        <Button
          plain
          color="white"
          onClick={() => {
            setActiveRuleSelectTab(null);
            setSelectedRules([]);
          }}
        >
          Cancel
        </Button>

        <Button
          color="blue"
          onClick={() => {
            const chosen = defaultRulesList
              .filter((r) => selectedRules.includes(r.id))
              .map((r) => r.text);

            // Apply selected default rules ONLY to active tab
            setTabs((prev) => {
              const updated = [...prev];
              updated[activeRuleSelectTab].rules = chosen.map((txt) => ({
                id: Date.now() + Math.random(),
                value: txt,
                isEditing: false,
              }));
              return updated;
            });

            setActiveRuleSelectTab(null);
            setSelectedRules([]);
          }}
        >
          Apply
        </Button>
      </div>
    </div>
  </div>
)}


    </div>
  );



}
